$bog_blitz_admin $mol_page
	Head null
	body <= admin_body /
	Quiz_card*0 $bog_blitz_admin_quiz
		quiz_title? <=> quiz_title*? \
		is_shared <= quiz_is_shared* false
		edit? <=> edit_quiz*? null
		delete? <=> delete_quiz*? null
		start? <=> start_quiz*? null
		duplicate? <=> duplicate_quiz*? null
		share? <=> share_quiz*? null
	Quizzes_list $mol_list
		rows <= quiz_rows /
	Create_button $mol_button_major
		title @ \Create Quiz
		click? <=> create_quiz? null
	Bot_expander $mol_expander
		title @ \AI Generate Quiz
		content /
			<= Bot $bog_blitz_admin_bot
				on_quiz? <=> import_bot_quiz? null
	Import_expander $mol_expander
		title @ \Import from JSON
		content /
			<= Import_hint $mol_paragraph
				title @ \Edit JSON below or import as a preset
			<= Import_area $mol_textarea
				value? <=> import_json_text? \
			<= Import_button $mol_button_major
				title @ \Import
				click? <=> import_json? null
	Back_button $mol_button_minor
		sub /
			<= Back_icon $mol_icon_arrow_left
			<= Back_label @ \Back to Quizzes
		click? <=> back_to_list? null
	Game_land_warning $mol_status
		sub /
			<= Game_land_warning_text $mol_paragraph
				title @ \This is a game session, not a quiz. Editing is not available.
	Editor $bog_blitz_admin_editor
		quiz_land <= current_quiz_land null
	Question*0 $bog_blitz_admin_question
		question <= question_obj*0 null
		number <= question_number*0 0
		question_text? <=> question_text*? \
		question_type? <=> question_type*? \choice
		delete? <=> delete_question*? null
		option_rows <= option_rows* /
		add_option? <=> add_option*? null
